import { __, trans, setLocale, getLocale, transChoice, MaticeLocalizationConfig, locales } from "matice"

export default {
    methods: {
        $t: __,
        $__: __,
        $transChoice: transChoice,
        $setLocale(locale) {
            setLocale(locale);
            this.$forceUpdate()
        },
        $locale() {
            return getLocale()
        },
        $locales() {
            return locales()
        }
    },
}